import { inject, Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SupabaseClientService } from '../services/supabase-client/supabase-client.service';
import { ENV } from '../core-ng/injection-token';

@Injectable()
export class SupabaseAuthInterceptor implements HttpInterceptor {
  private supabaseClientService = inject(SupabaseClientService);
  private environment = inject(ENV);
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return from(this.supabaseClientService.client.auth.getSession()).pipe(
      switchMap((session) => {
        const access_token = session.data.session?.access_token;
        const headers: Record<string, string> = {
          // Authorization: `Bearer ${access_token}`,
          apikey: this.environment.supabaseAnonKey,
          'Content-Type': 'application/json',
          Prefer: 'return=representation',
        };
        if (access_token) {
          //Use User Access Token for RLS authorization
          headers['Authorization'] = `Bearer ${access_token}`;
        }

        // Set Prefer header based on method
        if (req.method === 'DELETE') {
          headers['Prefer'] = 'return=minimal';
        } else {
          headers['Prefer'] = 'return=representation';
        }

        // Only for POST (add-one) request, set single object accept
        if (req.method === 'POST') {
          headers['Accept'] = 'application/vnd.pgrst.object+json';
        } else {
          headers['Accept'] = 'application/json';
        }

        const authReq = req.clone({ setHeaders: headers });
        return next.handle(authReq);
      }),
    );
  }
}
